export default "__VITE_PUBLIC_ASSET__34a55065__"